import type { AffordabilityRunRecord, OwnerOccupiedAffordabilityRunOutput } from 'api/btlApplicationForm/types';

export function getLatestOoAffordabilityOutput(
  runs: AffordabilityRunRecord[] | undefined,
): OwnerOccupiedAffordabilityRunOutput | undefined {
  if (!runs?.length) {
    return undefined;
  }

  const latestRun = [...runs].sort((runA, runB) => {
    const createdAtA = runA.createdAt ? new Date(runA.createdAt).getTime() : 0;
    const createdAtB = runB.createdAt ? new Date(runB.createdAt).getTime() : 0;

    return createdAtB - createdAtA;
  })[0];

  return latestRun?.ownerOccupiedOutput;
}

export function isOoAffordabilityPassed(
  runs: AffordabilityRunRecord[] | undefined,
  isAffordabilityRunRequired?: boolean,
): boolean {
  const latestOutput = getLatestOoAffordabilityOutput(runs);

  return Boolean(latestOutput?.isPassed && !isAffordabilityRunRequired);
}
